import { useEffect } from 'react';
import { useAuth, withAuthenticationRequired } from 'react-oidc-context';
import { Loader } from '@intellecteu/common-ui';
import { useNotifications } from './hooks';

const PrivateRoute = ({ children }: any) => {
  const auth = useAuth();
  const { error, signinRedirect, isLoading, isAuthenticated } = auth;
  const { showErrorMessage } = useNotifications();

  useEffect(() => {
    if (!error) return;
    signinRedirect().catch((err: unknown) => {
      console.error('signinRedirect after auth error failed', err);
    });
  }, [error, signinRedirect]);

  if (error) {
    return <div>Redirecting...</div>;
  }

  if (isLoading) {
    return <Loader.FullPage />;
  }

  if (isAuthenticated) {
    return children;
  }

  if (!isAuthenticated) {
    signinRedirect();
    return <div>Redirecting...</div>;
  }

  return showErrorMessage('Unable to sign in');
};

export default withAuthenticationRequired(PrivateRoute, {
  OnRedirecting: () => {
    return <div>Redirecting...</div>;
  },
});
